import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MessageService } from 'primeng/api';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { ContentService } from '@services/content.service';
import { parseJwt } from '@services/utils';

import { Paths } from '../app.routes';

@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
  messageService = inject(MessageService);
  contentService = inject(ContentService);
  router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log('Interceptor HttpErrorResponse:', error);

        let errorMsg = '';
        if (error?.error instanceof ErrorEvent) {
          console.log('This is client side error');
          errorMsg = `Error: ${error?.error?.message}`;
        } else {
          console.log('This is server side error');
          errorMsg = `Error Code: ${error?.status},  Message: ${error?.message}`;
        }

        if (!(this.router.url.indexOf('debug') > 0) && !environment.debug) {
          const token = parseJwt(request.headers.get('Authorization') || '');
          console.log('Error interceptor', { request, error, token });
        }

        if (request.url.indexOf('user') > -1) {
          console.log('Error loading user account', error);
          this.router.navigate([Paths.error], {
            queryParams: { code: error.status, message: error.message },
            queryParamsHandling: 'merge',
          });
        }

        // Report API return 500 when no reports are found
        // until we fix the API, we will ignore this error
        if (request.url.indexOf('quality') > -1 || request.url.indexOf('rollmap') > -1) {
          console.log('Suppressing error for report API');
          const response = new HttpResponse<any>({
            statusText: 'No reports found',
            body: {
              properties: [],
            },
          });
          return of(response);
        }

        if (request.url.indexOf('accountmembers') > -1) {
          console.log('Suppressing error account members');
          const response = new HttpResponse<any>({
            statusText: 'No account members found',
            body: [],
          });
          return of(response);
        }

        if (request.url.indexOf('eudr') > -1) {
          console.log('Suppressing eudr error');
          const response = new HttpResponse<any>({
            statusText: 'No eudr deliveries found',
            body: [],
          });
          return of(response);
        }

        switch (error.status) {
          case 401:
            this.router.navigate([Paths.error], {
              queryParams: { code: 401 },
              queryParamsHandling: 'merge',
            });
            break;
          case 404:
            this.messageService.add({
              severity: 'error',
              detail: `${this.contentService.texts.common.error}: ${error?.error?.traceId}`,
              summary: `${this.contentService.texts.common.errorFetchingData} ${error?.error?.message}`,
              life: 8000,
            });
            break;
          default:
            this.messageService.add({
              severity: 'error',
              detail: `${this.contentService.texts.common.errorFetchingData}: ${error?.error?.traceId}`,
              summary: `${this.contentService.texts.common.error ?? ''} ${error?.error?.status}`,

              life: 8000,
            });
        }

        return throwError(() => new Error(errorMsg));
      }),
    );
  }
}
